import { cineamoApiClient } from '../../apiClient';
import { buildUrlQuery, UrlQueryParameter } from '../../helpers/url-query-helper';
import { CinemaDto } from '../../models/cinema/CinemaDto.types';
import { CinemaFeaturedContentDto } from '../../models/cinema-featured-content/CinemaFeaturedContentDto';
import { CinemaFeaturedContentInputDto } from '../../models/cinema-featured-content/CinemaFeaturedContentInputDto';
import { CinemaFeaturedContentListResponse } from '../../types/ApiListResponse.types';
import { ApiResponse } from '../../types/ApiResponse.types';

type GetCinemaFeaturedContentsQueryParameter = UrlQueryParameter & {
    activeDatetime?: string;
};

export async function getCinemaFeaturedContents(
    cinemaId: CinemaDto['id'],
    params?: GetCinemaFeaturedContentsQueryParameter
): Promise<ApiResponse<unknown, CinemaFeaturedContentListResponse>> {
    return cineamoApiClient
        .get(`/cinemas/${cinemaId}/featured-contents${buildUrlQuery(params)}`)
        .then((response) => response.data)
        .catch(() => null);
}

export async function deleteCinemaFeaturedContent(
    cinemaId: CinemaDto['id'],
    cinemaFeaturedContentId: CinemaFeaturedContentDto['id']
): Promise<boolean> {
    return cineamoApiClient
        .delete(`/cinemas/${cinemaId}/featured-contents/${cinemaFeaturedContentId}`)
        .then((response) => response.status === 204)
        .catch(() => false);
}

export async function createCinemaFeaturedContent(
    cinemaId: CinemaDto['id'],
    data: CinemaFeaturedContentInputDto
): Promise<ApiResponse<CinemaFeaturedContentDto>> {
    return cineamoApiClient
        .post<ApiResponse<CinemaFeaturedContentDto>>(`/cinemas/${cinemaId}/featured-contents`, data)
        .then((response) => response.data)
        .catch((error) => error);
}

export async function updateCinemaFeaturedContent(
    cinemaId: CinemaDto['id'],
    cinemaFeaturedContentId: CinemaFeaturedContentDto['id'],
    data: CinemaFeaturedContentInputDto
): Promise<ApiResponse<CinemaFeaturedContentDto>> {
    return cineamoApiClient
        .patch<ApiResponse<CinemaFeaturedContentDto>>(
            `/cinemas/${cinemaId}/featured-contents/${cinemaFeaturedContentId}`,
            data
        )
        .then((response) => response.data)
        .catch((error) => error);
}
